const passwordProtected = [
  {
    lga: 'gold-coast'    
  }
]

module.exports = { passwordProtected }
